import React from "react";

export default class ViewTermsOfService extends React.Component {

  render() {
    const {terms, currentUser} = this.props
    const isContractor = currentUser?.roles?.contractor;

    return (
      <div className="termsOfServiceModalComponent">
        <div className="termsOfServiceModal">
          <div className="termsOfServiceWelcome">
            <h2>Welcome to Modern Angles</h2>
            <p>Before accessing the platform, you must agree to our Terms of Service</p>
            {isContractor && <p><strong>Key obligations include:</strong> You will not solicit clients of Modern Angles for 12 months prior to or 1 year after your engagement.</p>}
          </div>

          {terms && (
            <>
              {/* <small className="text-muted float-right">{terms.version}</small> */}

              <div className="termsOfServiceContent clearfix editorContent">
                <div dangerouslySetInnerHTML={{__html: terms.content}}/>
              </div>
            </>
          )}

          <div className="text-center mt-3">
            <button onClick={() => this.props.closeModal()} className="settingsButton companyButton closeButton m-0">Close</button>
          </div>
        </div>
      </div>
    );
  }
}